module.exports = __webpack_public_path__ + "img/sj.d2bf96e2.png";